import { useCallback, useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';

import { listCoaDocumentsApi } from 'api/coa';
import useRoles from 'common/hooks/useRoles';
import CoaDocumentsTable from './components/CoaDocumentsTable';
import UploadCoaButton from './components/UploadCoaButton';

const CoaManagement = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { uploadCoa: canUpload } = useRoles();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Certificates of Analysis - SmartOS';
  }, []);

  const loadDocuments = useCallback(() => {
    setLoading(true);
    return listCoaDocumentsApi()
      .then(setDocuments)
      .catch((error) => {
        enqueueSnackbar(
          error?.response?.errors?.[0]?.message || 'Failed to load Certificates of Analysis',
          { variant: 'error' }
        );
      })
      .finally(() => setLoading(false));
  }, [enqueueSnackbar]);

  useEffect(() => {
    loadDocuments();
  }, [loadDocuments]);

  return (
    <>
      <Grid
        container
        sx={{ px: 3, pt: 3, pb: 2 }}
        direction='row'
        justifyContent='space-between'
        alignItems='flex-end'
      >
        <Grid item sx={{ minHeight: 30, flexGrow: 1 }}>
          <Typography component='h1' variant='h5'>
            Certificates of Analysis
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            One PDF per NDC and lot.{' '}
            {canUpload
              ? 'Uploading again for the same NDC and lot replaces the existing certificate.'
              : 'Open a certificate to view it.'}
          </Typography>
        </Grid>
        {canUpload && (
          <Grid item>
            <UploadCoaButton onUploaded={loadDocuments} />
          </Grid>
        )}
      </Grid>

      <Grid item container sx={{ px: 3, pb: 4 }}>
        <CoaDocumentsTable documents={documents} loading={loading} />
      </Grid>
    </>
  );
};

export default CoaManagement;
